import { type ReactElement } from 'react';
import { Button } from '@/ui/primitives/Button';

type ProjectCsvMappingActionsProps = {
  cancelDisabled: boolean;
  updateDisabled: boolean;
  onCancel: () => void;
  onUpdate: () => void;
};

export const ProjectCsvMappingActions = ({
  cancelDisabled,
  updateDisabled,
  onCancel,
  onUpdate,
}: ProjectCsvMappingActionsProps): ReactElement => (
  <>
    <Button variant="ghost" fullWidthOnMobile={false} disabled={cancelDisabled} onClick={onCancel}>
      Cancel
    </Button>
    <Button
      variant="primary"
      fullWidthOnMobile={false}
      disabled={updateDisabled}
      onClick={onUpdate}
    >
      Update
    </Button>
  </>
);
